const welcome_banners_pt = require('./welcome_banners.json')
export default welcome_banners_pt